<template>
  <div class="cofre-form" data-testid="cofre-form">
    <div class="form-field">
      <label>{{ t('Nome da Conta') }} *</label>
      <input-text
        v-model="formData.nome"
        elem-id="cofre_nome"
        :placeholder="t('Ex: Itaú 1234-5')"
        required
        data-testid="input-cofre-nome"
      />
    </div>

    <div class="form-field">
      <label>{{ t('Banco') }}</label>
      <input-text
        v-model="formData.banco"
        elem-id="cofre_banco"
        :placeholder="t('Ex: Itaú')"
        data-testid="input-cofre-banco"
      />
    </div>

    <div class="form-row">
      <div class="form-field">
        <label>{{ t('Agência') }}</label>
        <input-text
          v-model="formData.agencia"
          elem-id="cofre_agencia"
          :placeholder="t('0000')"
          data-testid="input-cofre-agencia"
        />
      </div>
      <div class="form-field">
        <label>{{ t('Conta') }}</label>
        <input-text
          v-model="formData.conta"
          elem-id="cofre_conta"
          :placeholder="t('00000-0')"
          data-testid="input-cofre-conta"
        />
      </div>
    </div>

    <div class="form-field">
      <label>{{ t('Tipo de Conta') }}</label>
      <select-list
        v-model="formData.tipo"
        elem-id="cofre_tipo"
        :itens-select="tiposConta"
        data-testid="select-cofre-tipo"
      />
    </div>

    <div class="form-field" v-if="!conta?.id">
      <label>{{ t('Saldo Inicial') }}</label>
      <InputCurrency
        v-model="formData.saldo_atual"
        :placeholder="t('0,00')"
        data-testid="input-cofre-saldo"
      />
    </div>

    <div class="form-field">
      <label>{{ t('Observação') }}</label>
      <input-text
        v-model="formData.observacao"
        elem-id="cofre_observacao"
        :placeholder="t('Opcional')"
        data-testid="input-cofre-observacao"
      />
    </div>

    <div class="form-actions">
      <Button
        :label="t('Cancelar')"
        severity="secondary"
        outlined
        data-testid="btn-cancelar-cofre"
        @click="$emit('cancel')"
      />
      <Button
        :label="conta?.id ? t('Salvar') : t('Criar Conta')"
        icon="pi pi-check"
        severity="success"
        :loading="loading"
        :disabled="!isFormValid"
        data-testid="btn-submit-cofre"
        @click="$emit('submit', formData)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { reactive, computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps<{
  conta: any | null;
  loading: boolean;
}>();

defineEmits<{
  submit: [data: Record<string, any>];
  cancel: [];
}>();

const { t } = useI18n();

const tiposConta = [
  { ID: 'corrente', Name: t('Corrente') },
  { ID: 'poupanca', Name: t('Poupança') },
];

const formData = reactive<Record<string, any>>({
  nome: props.conta?.nome || '',
  banco: props.conta?.banco || '',
  agencia: props.conta?.agencia || '',
  conta: props.conta?.conta || '',
  tipo: props.conta?.tipo || 'corrente',
  saldo_atual: props.conta?.saldo_atual ? parseFloat(props.conta.saldo_atual) : null,
  observacao: props.conta?.observacao || '',
});

const isFormValid = computed(() => {
  return formData.nome && formData.nome.trim().length > 0;
});
</script>

<style scoped>
.form-field { margin-bottom: 16px; }
.form-field label { display: block; margin-bottom: 6px; font-weight: 500; font-size: 0.9rem; }
.form-row { display: flex; gap: 12px; }
.form-row .form-field { flex: 1; }
.form-actions { display: flex; justify-content: flex-end; gap: 8px; margin-top: 24px; }
</style>
